// src/pages/promotions/modals/RankForm.jsx
import { Modal, Form, Input, Button, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  useAddRankMutation,
  useUpdateRankMutation,
} from "@/services/api/promo/promoApi";
import { useEffect } from "react";

const RankForm = ({ open, onClose, mode, initialData, onSuccess }) => {
  const [form] = Form.useForm();
  const [addRank, { isLoading: adding }] = useAddRankMutation();
  const [updateRank, { isLoading: updating }] = useUpdateRankMutation();

  // Critical: Reset form when modal opens/closes or mode/data changes
  useEffect(() => {
    if (open) {
      if (mode === "add") {
        form.resetFields(); // Clear all
      } else if (mode === "edit" && initialData) {
        form.setFieldsValue({
          name: initialData.name,
          qualifying_order_no: initialData.qualifying_order_no?.toString(),
        });
      }
    } else {
      form.resetFields(); // Ensure clean state when closed
    }
  }, [open, mode, initialData, form]);

  const handleSubmit = async (values) => {
    try {
      const payload = {
        name: values.name,
        qualifying_order_no: parseInt(values.qualifying_order_no, 10),
      };

      if (mode === "add") {
        await addRank(payload).unwrap();
        message.success("Rank added successfully!");
      } else {
        await updateRank({ id: initialData.id, ...payload }).unwrap();
        message.success("Rank updated successfully!");
      }

      form.resetFields();
      onSuccess();
      // onClose();
    } catch (err) {
      message.error(err?.data?.message || "Operation failed");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={mode === "add" ? "Add Rank" : "Edit Rank"}
      width={600}
      closeIcon={
        <CloseOutlined style={{ fontSize: "18px", color: "#8c8c8c" }} />
      }
      footer={null}
      destroyOnClose
    >
      {open && (
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={initialData || {}}
          style={{ marginTop: "24px" }}
        >
          <Form.Item
            label={
              <span
                style={{ fontSize: "14px", fontWeight: 500, color: "#262626" }}
              >
                Rank Name
                <span style={{ color: "#ff4d4f", marginLeft: "4px" }}>*</span>
              </span>
            }
            name="name"
            rules={[{ required: true, message: "Please enter rank name" }]}
          >
            <Input
              placeholder="e.g. Returning"
              size="large"
              style={{ borderRadius: "6px", fontSize: "14px" }}
            />
          </Form.Item>

          <Form.Item
            label={
              <span
                style={{ fontSize: "14px", fontWeight: 500, color: "#262626" }}
              >
                Qualifying Order Amount
                <span style={{ color: "#ff4d4f", marginLeft: "4px" }}>*</span>
              </span>
            }
            name="qualifying_order_no"
            rules={[
              { required: true, message: "Please enter amount" },
              {
                pattern: /^[0-9]+$/,
                message: "Please enter a valid number",
              },
            ]}
          >
            <Input
              placeholder="e.g. 100"
              size="large"
              style={{ borderRadius: "6px", fontSize: "14px" }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, marginTop: "32px" }}>
            <div className="flex justify-end gap-3">
              <Button onClick={onClose} size="large">
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={adding || updating}
                size="large"
                style={{
                  backgroundColor: "#faad14",
                  borderColor: "#faad14",
                  fontWeight: 500,
                  fontSize: "16px",
                  height: "48px",
                  minWidth: "120px",
                  borderRadius: "6px",
                }}
              >
                {mode === "add" ? "Save" : "Update"}
              </Button>
            </div>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default RankForm;
